import UpdateVideoPostModal from "./UpdateVideoPostModal";

export default function UpdateVideoPost({ isOpen, onClose, video }) {
  return (
    <UpdateVideoPostModal isOpen={isOpen} onClose={onClose} video={video} />
  );
}
